import { configureStore } from '@reduxjs/toolkit';
import ItemsSlice from './items';
import GlobalSlice from './global';
import ItemValueSlice from './itemValues';
import NavigationSlice from './navigation';

export default configureStore({
  reducer: {
    items: ItemsSlice,
    global: GlobalSlice,
    itemValues: ItemValueSlice,
    navigation: NavigationSlice,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
